import varAxios from "../../Comman/axios";
import {GetAllCarouselSettingsUrl, AddCarouselSettingsUrl,
        DeleteCarouselSettingUrl, UpdateCarouselSettingUrl,updateCarouselSequenceUrl} from '../../Comman/apiEndPoints';

export const Fetch_All_CarouselSettings_Data = "Fetch_All_CarouselSettings_Data";
export const Update_Carousel_List_Success = "Update_Carousel_List_Success";
export const Carousel_Data_Success = "Carousel_Data_Success";
export const Fetch_Carousel_Setting_Request = "Fetch_Carousel_Setting_Request";

export function getAllCarouselSettings() {
    return(dispatch) =>{
       return varAxios.get(GetAllCarouselSettingsUrl)
       .then(response => {
          dispatch(
            fetchAllCarouselSettingsData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              carouselList : response.data.CarouselSetting
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllCarouselSettingsData({errorCode, statusCode, carouselList}) {
  return {
    type : Fetch_All_CarouselSettings_Data,
    errorCode,
    statusCode,
    carouselList
  }
}
export function addCarouselData(formData) {
  return (dispatch) => {
      dispatch(fetchCarouselSettingRequest())
      return varAxios.post(AddCarouselSettingsUrl, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                  updateCarouselList(response.data.errorCode,response.data.statusCode,
                    response.data.List,response.data.Message)
              );
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function updateCarouselList(errorCode,statusCode,UpdatedList,message) {
  return{
    type : Update_Carousel_List_Success,
    errorCode,
    statusCode,
    UpdatedList,
    message
  } 
}

export function deleteCarouselData(id) {
  return (dispatch) => {
    dispatch(fetchCarouselSettingRequest())
      return varAxios.delete(DeleteCarouselSettingUrl,{data : { Id : id}},
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                  CarouselDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.Message)
              );
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function CarouselDataSuccess(errorCode,statusCode,Message,list) {
  return{
    type : Carousel_Data_Success,
    errorCode,
    statusCode,
    Message,
    list
  } 
}
export function editCarouselData(formData) {
  return (dispatch) => {
    dispatch(fetchCarouselSettingRequest())
      return varAxios.post(UpdateCarouselSettingUrl, formData,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                CarouselDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.List)
              );
          })
          .catch((error) => {
              console.log(error)
          })
  }
}
export function fetchCarouselSettingRequest(){
  return{
    type : Fetch_Carousel_Setting_Request
  }
}
export function updateCarouselSequence(data) {
  return (dispatch) => {
    dispatch(fetchCarouselSettingRequest())
      return varAxios.post(updateCarouselSequenceUrl, data,
          JSON.stringify({
              derived: 'd',
              message: 'e'
          }))
          .then((response) => {
              dispatch(
                CarouselDataSuccess(response.data.errorCode,response.data.statusCode,
                  response.data.Message,response.data.carouselSetting)
              );
          })
          .catch((error) => {
              console.log(error)
          })
  }
}